import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import GoogleButton from './GoogleButton';
import AuthDivider from './AuthDivider';
import { loginWithEmail, loginWithGoogle } from '../../services/authService';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrar, setLembrar] = useState(true);
  const [erro, setErro] = useState('');
const [loading, setLoading] = useState(false);

 const handleSubmit = async (e) => {
  e.preventDefault();
  setErro('');
  setLoading(true);
  try {
    await loginWithEmail(email, senha);
    navigate('/dashboard');
  } catch (err) {
    setErro(err.code === 'auth/invalid-credential'
      ? 'E-mail ou senha incorretos.'
      : 'Erro ao fazer login. Tente novamente.');
  }
  setLoading(false);
};

const handleGoogle = async () => {
  try {
    await loginWithGoogle();
    navigate('/dashboard');
  } catch (err) {
    setErro('Erro ao entrar com Google.');
  }
};
  return (
    <div style={{
      fontFamily: 'var(--font)', color: 'var(--text)', background: 'var(--primary)',
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* BG decorations */}
      <div style={{ position: 'absolute', top: -200, right: -200, width: 700, height: 700, background: 'radial-gradient(circle, rgba(0,214,143,0.06) 0%, transparent 60%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -150, left: -150, width: 500, height: 500, background: 'radial-gradient(circle, rgba(245,166,35,0.04) 0%, transparent 60%)', pointerEvents: 'none' }} />
      <div style={{ position: 'fixed', inset: 0, opacity: 0.03, backgroundImage: 'linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)', backgroundSize: '60px 60px', pointerEvents: 'none' }} />

      {/* Card */}
      <div style={{
        background: 'var(--white)', borderRadius: 20, padding: '48px 44px',
        width: '100%', maxWidth: 440, position: 'relative', zIndex: 1,
        boxShadow: '0 40px 80px rgba(0,0,0,0.2)',
      }}>
        {/* Logo */}
        <Link to="/" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          textDecoration: 'none', color: 'var(--primary)', fontWeight: 700, fontSize: '1.3rem', marginBottom: 36,
        }}>
          <div style={{
            width: 36, height: 36, background: 'var(--primary)', borderRadius: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, color: 'var(--accent)', fontSize: '1.1rem',
          }}>S</div>
          SimulaBank
        </Link>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 6 }}>Bem-vindo de volta</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            Não tem conta? <Link to="/cadastro" style={{ color: 'var(--accent)', textDecoration: 'none', fontWeight: 600 }}>Criar conta grátis</Link>
          </p>
        </div>

       <GoogleButton label="Entrar com Google" onClick={handleGoogle} />
        <AuthDivider />

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 600, marginBottom: 6 }}>E-mail</label>
            <input type="email" required placeholder="joao@suaempresa.com.br" value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ width: '100%', padding: '12px 16px', border: '1.5px solid var(--border)', borderRadius: 'var(--radius-sm)', fontFamily: 'var(--font)', fontSize: '0.9rem', color: 'var(--text)', outline: 'none' }} />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 600, marginBottom: 6 }}>Senha</label>
            <input type="password" required placeholder="Sua senha" value={senha} onChange={(e) => setSenha(e.target.value)}
              style={{ width: '100%', padding: '12px 16px', border: '1.5px solid var(--border)', borderRadius: 'var(--radius-sm)', fontFamily: 'var(--font)', fontSize: '0.9rem', color: 'var(--text)', outline: 'none' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', color: 'var(--text-muted)', cursor: 'pointer' }}>
              <input type="checkbox" checked={lembrar} onChange={(e) => setLembrar(e.target.checked)} style={{ width: 16, height: 16, accentColor: 'var(--accent)', cursor: 'pointer' }} />
              Lembrar de mim
            </label>
            <a href="#" style={{ fontSize: '0.82rem', color: 'var(--accent)', textDecoration: 'none', fontWeight: 500 }}>Esqueceu a senha?</a>
          </div>

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: 14, background: 'var(--accent)', color: 'var(--primary)',
            border: 'none', borderRadius: 'var(--radius-sm)', fontFamily: 'var(--font)',
            fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer', transition: 'all 0.3s',
          }}>{loading ? 'Entrando...' : 'Entrar'}</button>
        </form>
{erro && <p style={{ color: '#EF4444', fontSize: '0.82rem', textAlign: 'center', marginTop: 12 }}>{erro}</p>}
        <div style={{ textAlign: 'center', marginTop: 24, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
          Protegido por criptografia SSL. <a href="#" style={{ color: 'var(--text)', textDecoration: 'underline' }}>Termos</a> · <a href="#" style={{ color: 'var(--text)', textDecoration: 'underline' }}>Privacidade</a>
        </div>
      </div>
    </div>
  );
}